import React from 'react';
import {Image} from 'react-bootstrap';
import Cards from 'react-credit-cards';
import {Wrapper} from './styles/CreditCard';
import CardPlaceholder from '../../../Images/card-placeholder-blue.png';
import BlockedCard from '../../../Images/tarjeta-bloqueada.svg'

const Card = ({url, cliente, bin, truncate, ...props}) => {
  return(
    <Wrapper 
        url={url}
        placeholder={CardPlaceholder}
        status={props?.unblocked}
        variant={props?.variant}
      >
      {
        props && props.unblocked === false ? 
          <Image style={{position: 'absolute', zIndex: '1', marginLeft: 'auto', marginRight: 'auto'}} src={BlockedCard}/>
            :
          ""
      }
         <Cards
           cvc={""}
           focus={""}
           name={cliente}
           placeholders={{name:''}}
           number={props.variant === 'register' ? '**** ****' + truncate : '**** **** ****' + bin}
           issuer={'mastercard'}
           preview={true}
           expiry={""}
         />
      </Wrapper>
  )
}

export default Card;